"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const QMenu_1 = __importDefault(require("components/QMenu"));
const AlarmOn_1 = __importDefault(require("@mui/icons-material/AlarmOn"));
const AlarmOff_1 = __importDefault(require("@mui/icons-material/AlarmOff"));
const types_1 = require("data/accountBalances/types");
const ScheduleViewMenu = (_a) => {
    var { reminderSetting, onChange, isWindows } = _a, _other = __rest(_a, ["reminderSetting", "onChange", "isWindows"]);
    return (<QMenu_1.default menuIcon={!reminderSetting || reminderSetting === 'off' || reminderSetting === '0' ? AlarmOff_1.default : AlarmOn_1.default} name="schedTxnMenu" title="Show reminders in register" 
    // @ts-expect-error: mediumNoPadding is a custom size not in QMenu types
    menuIconButtonSize="mediumNoPadding" options={[
            {
                label: 'Show reminders for',
                groupId: 'reminders',
                isGroupList: true,
                selected: String(reminderSetting !== null && reminderSetting !== void 0 ? reminderSetting : 0),
                groupList: isWindows ? types_1.schedTxViewsWindows : types_1.schedTxViewsMac,
            },
        ]} 
    // @ts-expect-error: onChange signature mismatch with QMenu expected type
    onChange={onChange}/>);
};
exports.default = ScheduleViewMenu;
